/**
 * Cookie notice
 */
;
(function () {

    'use strict';

    /**
     * Store current instance
     */
    var instance;

    /**
     * Defaults values
     * @type object
     */
    var defaults = {
        message: 'Our site uses cookies to personalize content andВ make our site easier for you to use.',
        position: 'right',
        moreLinkHref: '#',
        expiresIn: 30,
        disable: true
    };

    var cookieNoticeClass = 'm-cookie-notice';

    /**
     * Initialize cookie notice on DOMContentLoaded
     * if not already initialized with alt params
     */
    document.addEventListener('DOMContentLoaded', function () {
        if (!instance && !defaults.disable) {
            new cookieNotice();
        }
    });

    /**
     * Constructor
     * @constructor
     */
    window.cookieNotice = function () {

        // If an instance is already set stop here
        if (instance !== undefined) {
            return;
        }

        // Set current instance
        instance = this;

        // Create events
        var cookieDisabledEvent = document.createEvent('Event');
        var cookieEnabledEvent = document.createEvent('Event');

        // Define events
        cookieDisabledEvent.initEvent('cookieNoticeDisable', true, true);
        cookieEnabledEvent.initEvent('cookieNoticeEnable', true, true);

        // If cookies are not supported or notice cookie is already set
        if (!testCookie() || getNoticeCookie()) {
            document.dispatchEvent(cookieDisabledEvent);
            return;
        }

        // Extend default params
        var params = extendDefaults(defaults, arguments[0] || {});

        // Not create if disabled
        if (params.disable) {
            document.dispatchEvent(cookieDisabledEvent);
            return;
        }

        // say that cookie notice block enabled
        document.dispatchEvent(cookieEnabledEvent);

        // Create notice
        var notice = createNotice(
            params.message,
            params.position
        );

        // Create notice footer
        var noticeFooter = createNoticeFooter();

        // Create confirm link
        var confirmLink = createConfirmLink();

        // Confirm link click
        confirmLink.addEventListener('click', function (e) {
            e.preventDefault();

            // Set cookie
            setConfirmNoticeCookie(parseInt(params.expiresIn + "", 10) * 60 * 1000 * 60 * 24);

            // Check for jquery
            if ($) {
                var V = $.Velocity;
            } else {
                V = Velocity;
            }

            // Add velocity animation
            V(notice, 'transition.slideDownOut', {
                duration: 800,
                easing: '[0.23, 1, 0.32, 1]'
            });

            document.dispatchEvent(cookieDisabledEvent);
        });

        // Create footer links separator
        var linksSeparator = createLinksSeparator();

        // Create more info link
        var moreLink = createMoreLink(params.moreLinkHref);

        // Append notice to the DOM
        var noticeDomElement = document.body.appendChild(notice);

        // Append confirm link to notice footer
        noticeFooter.appendChild(confirmLink);

        // Append links separator to notice footer
        noticeFooter.appendChild(linksSeparator);

        // Append more link to notice footer
        noticeFooter.appendChild(moreLink);

        // Append footer to notice
        noticeDomElement.appendChild(noticeFooter);

    };

    /**
     * Test if cookies are enabled
     * @returns {boolean}
     */
    function testCookie() {
        document.cookie = 'testCookie=1';
        return document.cookie.indexOf('testCookie') !== -1;
    }

    /**
     * Test if notice cookie is there
     * @returns {boolean}
     */
    function getNoticeCookie() {
        return document.cookie.indexOf('cookie_notice') !== -1;
    }

    /**
     * Create notice container
     * @param message
     * @param position
     * @returns {HTMLDivElement}
     */
    function createNotice(message, position) {
        var notice = document.createElement('div');

        notice.innerHTML = message + '&nbsp;';
        notice.setAttribute('id', 'cookieNotice');
        notice.className = cookieNoticeClass;

        if (position === 'right') {
            notice.classList.add(cookieNoticeClass + '--right');
        }

        if (position === 'left') {
            notice.classList.add(cookieNoticeClass + '--left')
        }

        return notice;
    }

    /**
     * Create notice footer
     * @returns {HTMLDivElement}
     */
    function createNoticeFooter() {
        var footer = document.createElement('div');
        footer.classList.add(cookieNoticeClass + '--footer');

        return footer
    }

    /**
     * Create confirm link
     * @returns {HTMLAnchorElement}
     */
    function createConfirmLink() {
        var confirmLink = document.createElement('a');

        confirmLink.href = '#';
        confirmLink.innerHTML = 'Ok';

        confirmLink.className = cookieNoticeClass +'--confirm' + ' u-fw--bold u-wh u-inline-block u-uppercase';

        return confirmLink;
    }

    /**
     * Create more link
     * @param href
     * @returns {HTMLAnchorElement}
     */
    function createMoreLink(href) {
        var moreLink = document.createElement('a');

        moreLink.href = href;
        moreLink.textContent = 'More info';
        moreLink.target = '_blank';
        moreLink.className = cookieNoticeClass + '--more-link' + ' u-fw--bold u-wh u-inline-block u-uppercase';

        return moreLink;
    }

    function createLinksSeparator() {
        var separator = document.createElement('span');

        separator.textContent = 'or';
        separator.className = cookieNoticeClass + '--link-separator u-inline-block';

        return separator;
    }

    /**
     * Set confirm notice cookie
     * @param expireIn
     */
    function setConfirmNoticeCookie(expireIn) {
        var now = new Date(),
            cookieExpire = new Date();

        cookieExpire.setTime(now.getTime() + expireIn);
        document.cookie = "cookie_notice=1; expires=" + cookieExpire.toUTCString() + "; path=/;";
    }

    /**
     * Utility method to extend defaults with user options
     * @param source
     * @param properties
     * @returns {*}
     */
    function extendDefaults(source, properties) {
        var property;
        for (property in properties) {
            if (properties.hasOwnProperty(property)) {
                if (typeof source[property] === 'object') {
                    source[property] = extendDefaults(source[property], properties[property]);
                } else {
                    source[property] = properties[property];
                }
            }
        }
        return source;
    }


}());